var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('hardware-shop-badge',{on:{"openCart":function($event){return _vm.$router.push({ name: 'hardware-cart' })}}}),_c('hardware-shop-list',{attrs:{"loading":_vm.loading,"reference":_vm.reference}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }